import React from 'react';
import Dropzone from 'react-dropzone';
import {frendlyFormaterSizeInBytes, delay} from '@helpers/functions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';
import '@scss/fields.scss';
import {useTranslation} from "react-i18next";

const useStyles = makeStyles((theme) => ({
    fileRow: {
        paddingBottom: '15px',
    },
}));

function FileDropzone({files, onDrop, handleRemoveFile, handleDownloadFile}) {
    const allowedExt = ['jpg', 'jpeg', 'png', 'pdf'];
    const dropzoneProps = {
        multiple: true,
        onDrop,
    };
    const { t } = useTranslation();
    const classes = useStyles();
    const uploadedFileInfo = files
        ? <div>
            {
                files.map(file => {
                    return <div key={file.id} className={classes.fileRow}>
                               <span>
                                    <b>{t('photo_edit.uploaded')}</b>:
                                   &nbsp;
                                   <Link className="file-link" onClick={() => {
                                       delay(async () => {
                                           await handleDownloadFile(file.id);
                                       }, 200);
                                   }}>
                                       {file.name}
                                   </Link>
                                   &nbsp;
                                   ({frendlyFormaterSizeInBytes(file.size)})
                               </span>&nbsp;
                        <Button color="secondary" variant="outlined" size="small"
                                onClick={() => handleRemoveFile(file.id)}>
                            {t('delete')}
                        </Button>
                    </div>;
                })
            }
        </div>
        : null;
    return (
        <React.Fragment>
            <Dropzone {...dropzoneProps}>
                {({getRootProps, getInputProps, isDragActive}) => (
                    <div {...getRootProps({className: 'file-dropzone'})}>
                        <input {...getInputProps()} />
                        <Typography component={'p'}>
                            {isDragActive ? t('photo_edit.drag_to_place') : t('photo_edit.drag_to_place_additional')}
                        </Typography>
                        <Typography component={'p'}>
                            {t('photo_edit.allowed_file_ext')}: {allowedExt.join(', ')}
                        </Typography>
                    </div>
                )}
            </Dropzone>
            {uploadedFileInfo}
        </React.Fragment>
    );
}

export default FileDropzone;
